module.exports = "<div class=\"akloader\"\n     [@state]=\"loaderService.status\"\n     (@state.start)=\"animationChange($event)\"\n     (@state.done)=\"animationChange($event)\"\n     [class.hidden]=\"!show\">\n    <div>\n        <div class=\"icon beat\">{{loaderService.icon}}</div>\n        <div *ngIf=\"loaderService.text\">{{loaderService.text}}</div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loader/loader.component.html
// module id = 564
// module chunks = 0